var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

var Icon = function Icon(props) {
  return React.createElement('i', _extends({}, props, {
    className: cn('icon', 'icon-' + props.icon, props.className)
  }));
};

Icon.propTypes = {
  /** Icon name from icomoon */
  icon: PropTypes.string
};

export default Icon;